/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getShippingRates} from '../api'

 export const useQueryGetShippingRates = createReactQueryHook('getShippingRates', getShippingRates)
